import { render } from "./ProductModal.vue?vue&type=template&id=165600e0&scoped=true"
import script from "./ProductModal.vue?vue&type=script&lang=js"
export * from "./ProductModal.vue?vue&type=script&lang=js"

import "./ProductModal.vue?vue&type=style&index=0&id=165600e0&lang=scss"
import "./ProductModal.vue?vue&type=style&index=1&id=165600e0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165600e0"]])

export default __exports__